import { DialogId } from '@feedyou-ai/feedbot-schema'

export const actionTypes = {
  SET_TIMEOUT: 'SET_TIMEOUT',
  SET_DIALOG: 'SET_DIALOG'
} as const

export function setTimeout(timeout: number) {
  return { type: actionTypes.SET_TIMEOUT, timeout }
}

export function setDialog(dialogId: DialogId) {
  return { type: actionTypes.SET_DIALOG, dialogId }
}

export type Action = ReturnType<typeof setTimeout | typeof setDialog>
